<template>
  <b-overlay :show="loading">
    <ReceiptsFilters
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <div class="text-left mb-2 d-flex justify-content-start align-items-center">
      <div class="my-2 text-primary" v-if="filteredReceipts.length">
        <b-form-checkbox
          class="d-inline-block"
          v-model="selectAll"
          @change="selectAllReceipts"
        >
        </b-form-checkbox>
        Seleccionar todos
      </div>
      <b-button
        v-if="selectedReceipts.length"
        class="ml-4 badge-glow"
        variant="primary"
        v-has-permission="'ED183'"
        @click="invoiceMassiveReceipts()"
        size="sm"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-3"
        />
        <span class="align-middle">Facturar</span>
      </b-button>
      <b-button
        class="ml-4 badge-glow"
        variant="warning"
        v-on:click="onDownloadReceipts"
        size="sm"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-3"
        />
        <span class="align-middle">Descargar</span>
      </b-button>
    </div>
    <ReceiptsHeader />
    <div class="force-render" :key="forceRender">
      <ReceiptRow
        :is-massive="isMassive"
        :selected-receipts="selectedReceipts"
        :key="receipt.comprobanteId"
        v-for="receipt in filteredReceipts"
        :receipt="receipt"
        :select-receipt="selectReceipt"
        @select-check-receipt="selectCheckReceipt"
        @unselect-check-receipt="unSelectCheckReceipt"
        v-on:reload-list="handleReloadList"
      />
    </div>
    <div class="row">
      <div class="col-3">
        <div class="mt-5">
          Mostrando
          <select v-model="rowspp" @change="fetchReceipts()">
            <option value="10" selected="selected">10</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select> registros por página.
        </div>
      </div>
      <div class="col-9">
        <ReceiptsPagination
          :show="filteredReceipts.length"
          v-model="page"
        />
      </div>
    </div>
    <b-modal
      id="receipts-invoice"
      ref="receipts-invoice"
      :title="`Facturar Comprobantes`"
      hide-footer
    >
      <ReceiptsInvoice
        :receipts="selectedReceipts"
        @invoice="handleOnInvoice"
      />
    </b-modal>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import ReceiptRow from '@/febos/aduanas/receipts/views/components/ReceiptRow';
import ReceiptsHeader from '@/febos/aduanas/receipts/views/components/ReceiptsHeader';
import ReceiptsPagination from '@/febos/aduanas/receipts/views/components/ReceiptsPagination';
import ReceiptsFilters from '@/febos/aduanas/receipts/views/components/ReceiptsFilters';
import { selectReceiptState, fetchReceiptsList, selectAllElements } from '@/febos/aduanas/receipts/store/actions';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';
import { receipts, loading } from '@/febos/aduanas/receipts/store/getters';
import { INVOICE_STATES, receiptsCodeStates, receiptsStates } from '@/febos/aduanas/receipts/views/utils/constants';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import ReceiptsInvoice from '@/febos/aduanas/receipts/views/components/ReceiptsInvoice';
import { receiptsListSearch } from '@/febos/servicios/api/aduanas/receipts.api';

export default {
  components: {
    ReceiptsInvoice,
    ReceiptRow,
    ReceiptsHeader,
    ReceiptsPagination,
    ReceiptsFilters
  },
  data() {
    return {
      receiptsCodeStates,
      isMassive: false,
      selectAll: false,
      selectedReceipts: [],
      selectedReceipt: {},
      filters: '',
      textSearch: '',
      searchParam: false,
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      forceRender: Date.now() // TODO: the files watch is triggered but the component not re-render.
    };
  },
  watch: {
    async page(page) {
      updateSearchParams({ page });
      await this.fetchReceipts();
    }
  },
  computed: {
    ...mapGetters('receipts', {
      receipts: receipts.name,
      loading: loading.name
    }),
    filteredReceipts() {
      return this.receipts;
    }
  },
  methods: {
    ...mapActions('receipts', {
      selectReceiptState: selectReceiptState.name,
      fetchReceiptsList: fetchReceiptsList.name,
      selectAllElements: selectAllElements.name
    }),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    getFilters() {
      // Esta condición es para ver referencias en base a febosId
      if (this.$route.query?.filters) {
        if (this.$route.query.filters.includes('comprobanteId')) {
          return this.$route.query.filters;
        }
      }
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force fetch (if we change the page from 1 to 1 the watcher not run)
          await this.fetchReceipts();
        }
      }
    },
    fetchReceipts() {
      this.fetchReceiptsList({
        params: {
          filtros: this.getFilters(),
          orden: '-folio',
          paginaActual: this.page,
          elementosPorPagina: this.rowspp
        }
      });
    },
    selectAllReceipts() {
      this.selectAllElements(this.selectAll);
      if (this.selectAll) {
        this.isMassive = true;
        this.selectedReceipts.push(this.filteredReceipts);
      } else {
        this.isMassive = false;
        this.selectedReceipts = [];
      }
    },
    selectReceipt(receipt) {
      this.selectedReceipt = receipt;
      this.selectReceiptState(receipt.comprobanteId);
    },
    selectCheckReceipt(receipt) {
      this.selectedReceipts.push(receipt);
    },
    unSelectCheckReceipt(receipt) {
      this.selectedReceipts = this.selectedReceipts
        .filter((elm) => (elm.comprobanteId !== receipt.comprobanteId));
    },
    checkAllReceiptsInStates(states) {
      return this.selectedReceipts.every((batch) => states.includes(batch.estado));
    },
    invoiceMassiveReceipts() {
      const allInStateToInvoice = this.checkAllReceiptsInStates(INVOICE_STATES);
      if (allInStateToInvoice) {
        this.$refs['receipts-invoice'].show();
      } else {
        const statusNames = INVOICE_STATES.map((state) => receiptsStates[state].label);
        this.$vs.notify({
          title: 'Error',
          text: `Solo se pueden facturar comprobantes en estado${statusNames.length > 1
            ? 's' : ''
          }: ${statusNames.join(', ')}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: ALERT_POSITION
        });
      }
    },
    handleOnInvoice() {
      this.$refs['receipts-invoice'].hide();
      this.$emit('reload-list');
    },
    handleReloadList() {
      this.fetchReceipts();
    },
    async onDownloadReceipts() {
      this.$vs.notify({
        title: 'Solicitando',
        text: 'Descargando archivos',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      try {
        const { data } = await receiptsListSearch({
          filters: this.getFilters(),
          order: '-folio',
          format: 'csv'
        });
        window.open(data.url, '_blank');
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al descargar los registros',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
      }
    }
  },
  created() {
    this.closeModal();
    this.selectReceiptState('');
  },
  mounted() {
    this.fetchReceipts();
  }
};
</script>
